module.exports = __webpack_public_path__ + "img/精准分析1.2b8b7019.png";